import { updateDiagramColors, getDiagramColors } from '@process-advisor/process-miner/processMiner/processMiner';

export type DiagramColorsProps = {
    linkColor?: string;
    startNodeColor? :string;
    endNodeColor? :string;
    selectLinkColor?: string;
    animateColor?: string;
    loopColor?: string;
    nonCompliantColor?: string;
    automationColor?: string;
    partialNonCompliantColor?: string;
    partialAutomationColor?: string;
    visualizerBackgroundColor?: string;
}

export const changeColors = ({
    linkColor,
    startNodeColor,
    endNodeColor,
    selectLinkColor,
    animateColor,
    loopColor,
    nonCompliantColor,
    automationColor,
    partialNonCompliantColor,
    partialAutomationColor,
    visualizerBackgroundColor,
}: DiagramColorsProps) => updateDiagramColors({
    linkColor,
    startNodeColor,
    endNodeColor,
    selectLinkColor,
    animateColor,
    loopColor,
    nonCompliantColor,
    automationColor,
    partialNonCompliantColor,
    partialAutomationColor, 
    visualizerBackgroundColor,
});

export const getColors = (): DiagramColorsProps => getDiagramColors();
